import { c as _c } from "react/compiler-runtime";
import { postOrgPlaybooksEditSessionsByEditSessionIdModernize } from '@onefootprint/fetch-dashboard';
import { useRequestErrorToast } from '@onefootprint/hooks';
import { IcoArrowTopRight16, IcoWand16 } from '@onefootprint/icons';
import { Button, LinkButton } from '@onefootprint/ui';
import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { useStore } from '@/components/playbook-builder';
import { createEditSessionStore } from '@/hooks/use-in-progress-edit-session-storage';
type ModernizeProps = {
  canMigrate: boolean;
  onModernize: () => void;
};
const Modernize = t0 => {
  const $ = _c(22);
  const {
    canMigrate,
    onModernize
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "settingsDialog.modernize.migrate"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("playbook-builder", t1);
  const store = useStore();
  const {
    obcId,
    playbookId
  } = store.data;
  const errorToast = useRequestErrorToast();
  let t2;
  if ($[1] !== store) {
    t2 = async () => {
      const editSession = await store.getOrCreateEditSession();
      const {
        data
      } = await postOrgPlaybooksEditSessionsByEditSessionIdModernize({
        path: {
          editSessionId: editSession.id
        },
        body: {
          expectedLastGraphId: editSession.graphId
        }
      });
      return data;
    };
    $[1] = store;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== onModernize || $[4] !== store) {
    t3 = response => {
      store.setGraphUpdate(response);
      createEditSessionStore(response.playbookId).getState().update(response.startVersionId, response.id);
      onModernize();
    };
    $[3] = onModernize;
    $[4] = store;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== errorToast || $[7] !== t2 || $[8] !== t3) {
    t4 = {
      mutationFn: t2,
      onSuccess: t3,
      onError: errorToast
    };
    $[6] = errorToast;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const mutation = useMutation(t4);
  if (!obcId || !playbookId) {
    return null;
  }
  const now = Date.now();
  const datadogLogsUrl = `https://app.datadoghq.com/logs?query=source%3Arust%20env%3Aprod%20%22Legacy%20onboarding%20API%20hit%22%20%40pb_id%3A${playbookId}&agg_m=count&agg_m_source=base&agg_q=%40http.route&agg_t=count&clustering_pattern_field_path=message&cols=service%2C%40http.route%2C%40pb_id%2C%40has_email%2C%40has_phone_number%2C%40has_user_identifier&flat_group_bys=true&fromUser=true&messageDisplay=inline&refresh_mode=sliding&saved-view-id=2706789&sort_m=count&sort_t=count&storage=hot&stream_sort=time%2Cdesc&top_n=10&top_o=top&viz=query_table&x_missing=true&from_ts=${now - 2592000000}&to_ts=${now}&live=true`;
  let t5;
  if ($[10] !== t) {
    t5 = t(_temp);
    $[10] = t;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== datadogLogsUrl || $[13] !== t5) {
    t6 = <LinkButton href={datadogLogsUrl} target="_blank" iconComponent={IcoArrowTopRight16} iconPosition="right">{t5}</LinkButton>;
    $[12] = datadogLogsUrl;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== canMigrate || $[16] !== mutation || $[17] !== t) {
    t7 = canMigrate && <div className="flex flex-col gap-4"><div className="flex flex-col gap-1"><div className="flex gap-2 items-center"><IcoWand16 /><div className="text-label-2 text-primary">{t(_temp2)}</div></div><div className="text-body-2 text-secondary">{t(_temp3)}</div><div className="text-body-2 text-warning">{t(_temp4)}</div></div><Button className="self-start" variant="secondary" size="compact" loading={mutation.isPending} onClick={() => mutation.mutate(undefined)}>{t(_temp5)}</Button></div>;
    $[15] = canMigrate;
    $[16] = mutation;
    $[17] = t;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== t6 || $[20] !== t7) {
    t8 = <div className="flex flex-col gap-6">{t6}{t7}</div>;
    $[19] = t6;
    $[20] = t7;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  return t8;
};
export default Modernize;
function _temp($) {
  return $.auditIntegrations;
}
function _temp2($_0) {
  return $_0.title;
}
function _temp3($_1) {
  return $_1.description;
}
function _temp4($_2) {
  return $_2.caution;
}
function _temp5($_3) {
  return $_3.action;
}